import { gql } from '@apollo/client'

export const GET_ALL_GROUPS_CATEGORIES_SUBS = gql`
    query GetAllGroupsCategoriesSub($filterContext: Boolean) {
        getAllGroupsCategoriesSub(filterContext: $filterContext) {
            count
            rows {
                id
                name
            }
        }
    }
`


export const GET_ALL_GROUPS_CATEGORIES_SUBS_BY_CATEGORY_ID = gql`
    mutation GetAllGroupsCategoriesSubByCategoryId($getAllGroupsCategoriesSubByCategoryIdId: Int!) {
        getAllGroupsCategoriesSubByCategoryId(id: $getAllGroupsCategoriesSubByCategoryIdId) {
            id
            name
        }
    }
`

export const GET_ALL_GROUPS_CATEGORIES_SUBS_BY_ARRAY_CATEGORY_ID = gql`
  mutation GetAllGroupsCategoriesSubByArrayCategoryId(
    $array_group_category_id: [Int!]
  ) {
    getAllGroupsCategoriesSubByArrayCategoryId(
      array_group_category_id: $array_group_category_id
    ) {
      id
      name
      description
      group_category_id
    }
  }
`
